import {Helmet} from '@common/seo/helmet';

interface Props {
  title: string;
  description: string;
  url: string;
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Renders this page's own title/description/canonical on the client, as a
// raw tag string (same mechanism default-meta-tags.tsx uses for the
// homepage). Needed because any <Helmet> render on the page — including the
// site's own DefaultMetaTags — wipes out whatever the server rendered in
// <head> and replaces it, so pages with their own SEO tags must re-assert
// their own values on the client instead of rendering DefaultMetaTags.
export function PageSeo({title, description, url}: Props) {
  const safeTitle = escapeHtml(title);
  const safeDescription = escapeHtml(description);
  const safeUrl = escapeHtml(url);

  const html = `
    <title>${safeTitle}</title>
    <meta name="description" content="${safeDescription}" />
    <meta property="og:title" content="${safeTitle}" />
    <meta property="og:description" content="${safeDescription}" />
    <meta property="og:url" content="${safeUrl}" />
    <link rel="canonical" href="${safeUrl}" />
  `;

  return <Helmet tags={html} />;
}
